/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CurrentQuestionDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { SubmitAnswerRequestDto } from '../models';
// @ts-ignore
import type { SubmitAnswerResponseDto } from '../models';
// @ts-ignore
import type { SurveyStatusInfoDto } from '../models';
/**
 * SurveyParticipationApi - axios parameter creator
 * @export
 */
export const SurveyParticipationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get current question for user in survey
         * @param {number} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentQuestion: async (surveyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('getCurrentQuestion', 'surveyId', surveyId)
            const localVarPath = `/api/v2/surveys/{surveyId}/questions/current`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get survey status and progress for current user
         * @param {number} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyStatus: async (surveyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('getSurveyStatus', 'surveyId', surveyId)
            const localVarPath = `/api/v2/surveys/{surveyId}/status`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Starts the survey execution for the current employee: - Sets execution status to IN_PROGRESS - Creates all answer placeholders for questions assigned to this employee - Assigns local question numbers (1, 2, 3...) to answers 
         * @summary Start survey for current user
         * @param {number} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSurvey: async (surveyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('startSurvey', 'surveyId', surveyId)
            const localVarPath = `/api/v2/surveys/{surveyId}/start`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit answer to current question
         * @param {number} surveyId 
         * @param {SubmitAnswerRequestDto} submitAnswerRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitAnswer: async (surveyId: number, submitAnswerRequestDto: SubmitAnswerRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('submitAnswer', 'surveyId', surveyId)
            // verify required parameter 'submitAnswerRequestDto' is not null or undefined
            assertParamExists('submitAnswer', 'submitAnswerRequestDto', submitAnswerRequestDto)
            const localVarPath = `/api/v2/surveys/{surveyId}/answers`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitAnswerRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveyParticipationApi - functional programming interface
 * @export
 */
export const SurveyParticipationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurveyParticipationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get current question for user in survey
         * @param {number} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentQuestion(surveyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentQuestionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentQuestion(surveyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyParticipationApi.getCurrentQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get survey status and progress for current user
         * @param {number} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveyStatus(surveyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyStatusInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveyStatus(surveyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyParticipationApi.getSurveyStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Starts the survey execution for the current employee: - Sets execution status to IN_PROGRESS - Creates all answer placeholders for questions assigned to this employee - Assigns local question numbers (1, 2, 3...) to answers 
         * @summary Start survey for current user
         * @param {number} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startSurvey(surveyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyStatusInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startSurvey(surveyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyParticipationApi.startSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submit answer to current question
         * @param {number} surveyId 
         * @param {SubmitAnswerRequestDto} submitAnswerRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitAnswer(surveyId: number, submitAnswerRequestDto: SubmitAnswerRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmitAnswerResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitAnswer(surveyId, submitAnswerRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyParticipationApi.submitAnswer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SurveyParticipationApi - factory interface
 * @export
 */
export const SurveyParticipationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurveyParticipationApiFp(configuration)
    return {
        /**
         * 
         * @summary Get current question for user in survey
         * @param {number} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentQuestion(surveyId: number, options?: RawAxiosRequestConfig): AxiosPromise<CurrentQuestionDto> {
            return localVarFp.getCurrentQuestion(surveyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get survey status and progress for current user
         * @param {number} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyStatus(surveyId: number, options?: RawAxiosRequestConfig): AxiosPromise<SurveyStatusInfoDto> {
            return localVarFp.getSurveyStatus(surveyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Starts the survey execution for the current employee: - Sets execution status to IN_PROGRESS - Creates all answer placeholders for questions assigned to this employee - Assigns local question numbers (1, 2, 3...) to answers 
         * @summary Start survey for current user
         * @param {number} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSurvey(surveyId: number, options?: RawAxiosRequestConfig): AxiosPromise<SurveyStatusInfoDto> {
            return localVarFp.startSurvey(surveyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit answer to current question
         * @param {number} surveyId 
         * @param {SubmitAnswerRequestDto} submitAnswerRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitAnswer(surveyId: number, submitAnswerRequestDto: SubmitAnswerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SubmitAnswerResponseDto> {
            return localVarFp.submitAnswer(surveyId, submitAnswerRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SurveyParticipationApi - interface
 * @export
 * @interface SurveyParticipationApi
 */
export interface SurveyParticipationApiInterface {
    /**
     * 
     * @summary Get current question for user in survey
     * @param {number} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyParticipationApiInterface
     */
    getCurrentQuestion(surveyId: number, options?: RawAxiosRequestConfig): AxiosPromise<CurrentQuestionDto>;

    /**
     * 
     * @summary Get survey status and progress for current user
     * @param {number} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyParticipationApiInterface
     */
    getSurveyStatus(surveyId: number, options?: RawAxiosRequestConfig): AxiosPromise<SurveyStatusInfoDto>;

    /**
     * Starts the survey execution for the current employee: - Sets execution status to IN_PROGRESS - Creates all answer placeholders for questions assigned to this employee - Assigns local question numbers (1, 2, 3...) to answers 
     * @summary Start survey for current user
     * @param {number} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyParticipationApiInterface
     */
    startSurvey(surveyId: number, options?: RawAxiosRequestConfig): AxiosPromise<SurveyStatusInfoDto>;

    /**
     * 
     * @summary Submit answer to current question
     * @param {number} surveyId 
     * @param {SubmitAnswerRequestDto} submitAnswerRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyParticipationApiInterface
     */
    submitAnswer(surveyId: number, submitAnswerRequestDto: SubmitAnswerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SubmitAnswerResponseDto>;

}

/**
 * SurveyParticipationApi - object-oriented interface
 * @export
 * @class SurveyParticipationApi
 * @extends {BaseAPI}
 */
export class SurveyParticipationApi extends BaseAPI implements SurveyParticipationApiInterface {
    /**
     * 
     * @summary Get current question for user in survey
     * @param {number} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyParticipationApi
     */
    public getCurrentQuestion(surveyId: number, options?: RawAxiosRequestConfig) {
        return SurveyParticipationApiFp(this.configuration).getCurrentQuestion(surveyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get survey status and progress for current user
     * @param {number} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyParticipationApi
     */
    public getSurveyStatus(surveyId: number, options?: RawAxiosRequestConfig) {
        return SurveyParticipationApiFp(this.configuration).getSurveyStatus(surveyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Starts the survey execution for the current employee: - Sets execution status to IN_PROGRESS - Creates all answer placeholders for questions assigned to this employee - Assigns local question numbers (1, 2, 3...) to answers 
     * @summary Start survey for current user
     * @param {number} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyParticipationApi
     */
    public startSurvey(surveyId: number, options?: RawAxiosRequestConfig) {
        return SurveyParticipationApiFp(this.configuration).startSurvey(surveyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit answer to current question
     * @param {number} surveyId 
     * @param {SubmitAnswerRequestDto} submitAnswerRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyParticipationApi
     */
    public submitAnswer(surveyId: number, submitAnswerRequestDto: SubmitAnswerRequestDto, options?: RawAxiosRequestConfig) {
        return SurveyParticipationApiFp(this.configuration).submitAnswer(surveyId, submitAnswerRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

